import { FC } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { ColorsEnum } from '../../../constants/colors'
import { FontsEnum } from '../../../constants/fonts'
import { useAppSelector } from '../../../hooks/redux'
import { appSelectors } from '../../../redux/reducers/app'

interface ZoneBarProps {
    zoneName: string
    address: string
    driverName?: string
}

const ZoneBar: FC<ZoneBarProps> = ({ zoneName, address, driverName }) => {
    const isArchive = useAppSelector(appSelectors.isArchive)

    return (
        <View style={styles.container}>
            <Text style={styles.text}>
                {zoneName}
                {address ? ` - ${address}` : ''}
            </Text>
            <Text style={styles.text}>{driverName ?? isArchive ? 'nemá řidiče' : ''}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: ColorsEnum.YELLOW,
        padding: 14,
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 16,
    },
})

export default ZoneBar
